import * as React from 'react';
import Connect from 'view/connect/_connect';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { SaveTokenFunc } from 'coral-utility';

const routes = (
  <BrowserRouter>
    <Switch>
      <Route path="/save-token" component={SaveTokenFunc} />
      <Route render={() => <Connect />} />
    </Switch>
  </BrowserRouter>
);

export default routes;
